import { JourneyPosition } from '@yard/components/YardPositionSelector/models/journey-position'
import { makeAutoObservable } from 'mobx'
import { getResolutionActions, ResolutionActionType } from '../../helpers/yard-issues.helper'
import { YardIssueDto } from '../../models/yard-issue.model'

export class YardIssueResolveDialogUIStore {
  issue?: YardIssueDto
  selectedJourneyId?: number
  journeyPosition?: JourneyPosition
  selectedAction?: ResolutionActionType
  positionBlocked = false

  constructor() {
    makeAutoObservable(this)
  }

  setIssue(issue?: YardIssueDto) {
    this.issue = issue
    this.selectedJourneyId =
      issue?.conflictingJourneyIds.length === 1 ? issue.conflictingJourneyIds[0] : undefined
    this.journeyPosition = undefined
    this.selectedAction = this.defaultAction
  }

  setSelectedJourneyId(journeyId: number) {
    this.selectedJourneyId = journeyId
    this.journeyPosition = undefined
  }

  setJourneyPosition(journeyPosition?: JourneyPosition) {
    this.journeyPosition = journeyPosition
  }

  setPositionBlocked(positionBlocked: boolean) {
    this.positionBlocked = positionBlocked
  }

  setSelectedAction(action?: ResolutionActionType) {
    this.selectedAction = action
    this.journeyPosition = undefined
    this.positionBlocked = false
  }

  reset() {
    this.issue = undefined
    this.selectedJourneyId = undefined
    this.journeyPosition = undefined
    this.selectedAction = undefined
    this.positionBlocked = false
  }

  get availableActions(): ResolutionActionType[] {
    return this.issue ? getResolutionActions(this.issue.issueType) : []
  }

  get defaultAction(): ResolutionActionType | undefined {
    return this.availableActions[0]
  }

  get hasResolutionAction() {
    return !!this.defaultAction
  }

  get shouldShowJourneyPicker() {
    return this.hasResolutionAction && !!this.issue && this.issue.conflictingJourneyIds.length > 1
  }

  get confirmDisabled() {
    return (
      !this.hasResolutionAction ||
      !this.selectedJourneyId ||
      !this.journeyPosition ||
      this.positionBlocked
    )
  }
}
